module.exports = __webpack_public_path__ + "static/media/away.0c697a4c.svg";